import { useContext } from "react";
import {} from "../Contexts";
import { FileUploaderContext } from "../Contexts";

export const useFileUploader = () => {
  const context = useContext(FileUploaderContext);
  if (context === undefined) {
    throw new Error(
      "useFileUploader must be used within a FileUploaderProvider"
    );
  }
  return context;
};
